import AboutAppIcon from './component'

export default AboutAppIcon